import { useEffect, useReducer } from "react";
import { subscribeByKey } from "./boards-event-bus";

/**
 * Forces a re-render of the column toolbar when project metadata or task
 * composition changes for the given project.
 *
 * Subscribes to:
 *   - "project-updated"       (project tearsheet edits: name, dates, times, bid rate)
 *   - "column-tasks-changed"  (assignments/requests added, removed, or edited)
 *
 * The toolbar already reads fresh data from Bryntum stores on every render,
 * so a force-update is all that's needed to pick up changed values.
 */
export function useColumnToolbarUpdate(projectId: string): void {
   const [, forceUpdate] = useReducer((x: number) => x + 1, 0);

   useEffect(() => {
      const unsubProject = subscribeByKey("project-updated", "projectId", projectId, forceUpdate);
      const unsubTasks = subscribeByKey(
         "column-tasks-changed",
         "projectId",
         projectId,
         forceUpdate,
      );

      return () => {
         unsubProject();
         unsubTasks();
      };
   }, [projectId]);
}
